import styled from 'styled-components'

export const EmsErrorContainer = styled.div`
  width: 80%;
  border: 5px solid red;
  background-color: white;
  text-align: center;
`
